import { yupResolver } from "@hookform/resolvers/yup";
import FormHubSelect from "components/Common/Form/FormHubSelect";
import FormInput from "components/Common/Form/FormInput";
import MessageFormValidate from "components/shared-components/MessageFormValidate";
import {
  useCreatePaymentMethod,
  useUpdatePaymentMethod,
} from "hooks/payment-method/usePaymentMethod";
import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { Button, Col, FormGroup, Input, Label, Row } from "reactstrap";
import * as yup from "yup";
import { PaymentMethodType } from "./contants";
import { Switch } from "antd";

const validateSchema = t => {
  const rules = {
    hub: yup
      .object()
      .required(t("message.required", { title: t("form.hub") }))
      .nullable(),
    type: yup
      .object()
      .required(t("message.required", { title: t("form.type") }))
      .nullable(),
    name: yup
      .string()
      .required(t("message.required", { title: t("form.name") })),
    code: yup
      .string()
      .required(t("message.required", { title: t("form.code") })),
  };
  const schema = yup.object().shape(rules);
  return schema;
};

const PaymentMethodForm = ({
  mode,
  detail,
  onCancel,
  fetchPaymentMethodList,
}) => {
  const { t } = useTranslation(["paymentMethod"]);
  // const [is_level_2, setIsLevel2] = useState(true);
  const mainForm = useForm({
    resolver: yupResolver(validateSchema(t)),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      hub: undefined,
      type: undefined,
      name: "",
      code: "",
      description: undefined,
    },
  });
  const {
    control,
    formState: { errors },
    trigger,
    getValues,
    reset,
    setValue,
  } = mainForm;

  const onPaymentMethodSuccess = () => {
    mainForm.reset();
    fetchPaymentMethodList();
    onCancel();
  };

  const createPaymentMethodMutate = useCreatePaymentMethod(
    onPaymentMethodSuccess
  );

  const updatePaymentMethodMutate = useUpdatePaymentMethod(
    onPaymentMethodSuccess
  );

  const onSubmitForm = () => {
    trigger().then(result => {
      if (result) {
        const formValue = getValues();
        const bodyData = {
          code: formValue.code,
          description: formValue.description,
          hub_id: formValue.hub?.value ? Number(formValue.hub.value) : null,
          name: formValue.name,
          type: formValue.type.value,
        };
        if (mode === "CREATE") {
          createPaymentMethodMutate.mutate(bodyData);
        }

        if (mode === "UPDATE") {
          updatePaymentMethodMutate.mutate({
            id: detail.id,
            data: bodyData,
          });
        }
      }
    });
  };

  useEffect(() => {
    if (mode === "UPDATE" && detail) {
      reset({
        ...detail,
        hub: {
          label: detail.hub?.name,
          value: detail.hub?.id,
        },
        type: {
          label: t(
            `payment_method_type.${
              Object.entries(PaymentMethodType).find(
                ([_, value]) => value === detail.type
              )?.[0]
            }`
          ),
          value: detail.type,
        },
      });
    }
  }, [mode, detail]);

  // const handleChangeIsLevel2 = value => {
  //   setIsLevel2(value);
  //   setValue("hub", null, { shouldDirty: true, shouldTouch: true });
  // };

  return (
    <>
      <Row className="mb-2">
        <Col>
          {/* <Label
            className="d-flex align-items-center gap-1"
            style={{ cursor: "pointer" }}
            htmlFor="is_level_2"
            onClick={() => handleChangeIsLevel2(!is_level_2)}
          >
            <Switch checked={is_level_2} onChange={handleChangeIsLevel2} />
            Địa chỉ 2 cấp
          </Label> */}
        </Col>
      </Row>
      <Row>
        <Col xs={12} md={6}>
          <FormHubSelect
            // key={`hub-${is_level_2 ? 2 : 3}`}
            isRequired
            isMyHubOnly
            addressLevel={3}
            mainForm={mainForm}
            fieldName="hub"
            t={t}
            title={t("form.hub")}
          />
        </Col>
        <Col xs={12} md={6}>
          <FormGroup>
            <Label htmlFor="type">
              {t("form.type")} <span className="text-danger">*</span>
            </Label>
            <Controller
              control={control}
              name="type"
              render={({ field }) => (
                <Select
                  {...field}
                  placeholder={t("placeholder.select", {
                    title: t("form.type"),
                  })}
                  options={Object.keys(PaymentMethodType).map(key => ({
                    label: t(`payment_method_type.${key}`),
                    value: PaymentMethodType[key],
                  }))}
                  isSearchable
                  className="basic-single w-100"
                  classNamePrefix="select"
                />
              )}
            />
            {errors.type && <MessageFormValidate error={errors.type.message} />}
          </FormGroup>
        </Col>
        <Col xs={12} md={6}>
          <FormGroup>
            <Label htmlFor="code">
              {t("form.code")} <span className="text-danger">*</span>
            </Label>
            <FormInput
              isLabel={false}
              isRequired
              t={t}
              fieldName="code"
              type="text"
              mainForm={mainForm}
              title={t("placeholder.enter", {
                title: t("form.code"),
              })}
            />
          </FormGroup>
        </Col>
        <Col xs={12} md={6}>
          <FormGroup>
            <Label htmlFor="name">
              {t("form.name")} <span className="text-danger">*</span>
            </Label>
            <FormInput
              isLabel={false}
              isRequired
              t={t}
              fieldName="name"
              type="text"
              mainForm={mainForm}
              title={t("placeholder.enter", {
                title: t("form.name"),
              })}
            />
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label htmlFor="description">{t("form.note")}</Label>
            <Controller
              control={control}
              name="description"
              render={({ field }) => <Input {...field} type="textarea" />}
            />
            {errors.description && (
              <MessageFormValidate error={errors.description.message} />
            )}
          </FormGroup>
        </Col>
      </Row>

      <Row className="text-end">
        <Col>
          <Button size="xs" color="danger" onClick={onCancel} className="mx-3">
            {t("actions.cancel")}
          </Button>
          <Button
            size="xs"
            color="primary"
            style={{ backgroundColor: "#3C64B1" }}
            onClick={onSubmitForm}
          >
            {t("actions.submit")}
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default PaymentMethodForm;
